import type { Persisted, PollResponse } from '@tunasong/schemas'
import { UserAvatar } from '@tunasong/ui-lib'
import type { FC } from 'react'
import type { SlotAttendance } from './poll-outcome.js'
import { formatAttendanceDetail, formatAvailability } from './poll-outcome.js'
import styles from './attendance-line.module.css'

export interface AttendanceLineProps {
  attendance: SlotAttendance
  /**
   * The yes-voters, and only ever the yes-voters. Omit to render the numbers alone — the
   * dates that lost are a tally, not a guest list.
   */
  voters?: Persisted<PollResponse>[]
}

/**
 * Who is coming to one date, in one line.
 *
 * The avatars answer "who", the first number answers "how many of us", and the detail answers
 * the question the avatars cannot: a member with no avatar said no, said maybe, or never
 * replied — three different facts that look identical when only the yeses are drawn.
 */
export const AttendanceLine: FC<AttendanceLineProps> = props => {
  const { attendance, voters } = props

  const detail = formatAttendanceDetail(attendance)

  return (
    <span className={styles.line}>
      <span className={styles.available}>{formatAvailability(attendance)}</span>
      {detail ? <span className={styles.detail}>{detail}</span> : null}
      {voters && voters.length > 0 ? (
        <span className={styles.avatars}>
          {voters.map(voter => (
            <UserAvatar key={voter.id} userId={voter.userId} />
          ))}
        </span>
      ) : null}
    </span>
  )
}

export default AttendanceLine
